import { Image, Text, View } from '@react-pdf/renderer';

import ErrorImage from 'assets/images/error.png';

const ErrorPdfPage = () => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '80px'
      }}
    >
      <Image src={ErrorImage} style={{ width: '24px', height: '24px' }} />

      <Text style={{ fontSize: '14px', fontWeight: 'light', color: '#151515' }}>
        There&apos;s not enough data to display this chart.
      </Text>

      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '-8px',
          fontSize: '12px',
          fontWeight: 'light',
          color: '#9B9B9B'
        }}
      >
        <Text>
          We set a minimum sample size in order to maintain data fidelity
        </Text>

        <Text>and privacy - please adjust the filters you&apos;re using.</Text>
      </View>
    </View>
  );
};

export default ErrorPdfPage;
